var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ProductionManagement"},[_c('AppHeader',[_vm._v("课包管理")]),_c('AppBox',{staticClass:"appBox",attrs:{"id":"appBox"}},[[_c('ProductionList',{attrs:{"maxHeight":_vm.maxHeight}})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }